import axios from "axios";
import { BACKEND } from "../../config/configEnvs";
import { toast } from "react-toastify";
import ActualizarHistorialMultiplesPagosCotizaciones from "./ActualizarHistorialMultiplesPagosCotizaciones";
import { useSelector } from "react-redux";

export async function CrearMultiplesPagos(total, numeroPagos, fechaInicial, idCotizacion, userId, servicios) {

  const toastId = toast.loading("Generando pagos...");

  try {
    const montoPorPago = total / numeroPagos;
    const pagos = [];

    const montosServicios = servicios.map(s => ({servicioId: s.id, monto: 0, igv: s.igv}))

    for (let i = 0; i < numeroPagos; i++) {
      // Crear fecha para este pago sumando i meses a la fecha inicial
      const fechaPago = new Date(fechaInicial);
      fechaPago.setMonth(fechaPago.getMonth() + i);

      const pago = {
        cotizacion: idCotizacion,
        descripcion: `${i + 1}° pago`,
        precio: montoPorPago,
        percentage: (montoPorPago / total) * 100,
        fechaLimite: fechaPago.toISOString().split('T')[0],
        pagado: false,
        montosServicios: montosServicios
      };

      // Hacer la petición al servidor para crear el pago
      const response = await axios.post(`${BACKEND}/api/pagosCotizaciones`, pago, {withCredentials: true});
      pagos.push(response.data.doc);
    }

    ActualizarHistorialMultiplesPagosCotizaciones({
      idCotizacion: idCotizacion,
      pagos: pagos,
      tipoEvento: "Pago añadido",
      idUsuario: userId,
      detalles: "Múltiples pagos creados"
    })

    toast.update(toastId, {
      render: "Pagos creados correctamente",
      type: "success",
      isLoading: false,
      autoClose: 3000
    });

    return pagos;

  } catch (error) {
    toast.update(toastId, {
      render: "Error al crear los pagos: " + error,
      type: "error", 
      isLoading: false,
      autoClose: 3000
    });
  }
}
